<template>
  <div class="new content-wrapper" v-if="linkbuilding">
    <h1>{{ getTitle }}</h1>

    <LinkBuilding :linkbuilding="linkbuilding"></LinkBuilding>

    <div v-if="linkbuilding.status === 'Pending Review'">
      Your linkbuilding text is waiting to be reviewed and cannot be edited further at this time..
    </div>
    <div v-else-if="linkbuilding.status == 'Draft' || linkbuilding.status == 'Revision Needed'" class="button-container">
      <button class="button" @click="save">Save Draft</button>
      <button class="button button--margin-left" @click="publish">Submit for Review</button>
      <span class="delete" @click="deleteLinkBuilding">
        <!-- prettier-ignore -->
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"><path fill="#bcbccb" d="M1.071 0L10 8.929l-1.072 1.07L0 1.072z"/><path fill="#bcbccb" d="M10 1.071L1.071 10 .001 8.928 8.928 0z"/></svg>
        Delete
      </span>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'
import axios from 'axios'
import LinkBuilding from '@/components/linkbuilding'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'id',
  data() {
    return {
      emptyFields: [],
    }
  },
  mounted: async function() {
    await this.fetchContentById({ collection: 'linkbuilding', documentId: this.$route.params.id })
  },
  methods: {
    ...mapActions(['publishContentById', 'saveContentById', 'fetchContentById', 'deleteContentById']),

    fieldsCompleted() {
      const fieldsToVerify = [
        { linkbuilding: this.linkbuilding.languageId, name: 'language' },
        { linkbuilding: this.linkbuilding.content, name: 'content' },
        { linkbuilding: this.linkbuilding.orderedById, name: 'ordered by' },
      ]

      this.emptyFields = fieldsToVerify.filter(field => {
        if (field.linkbuilding.length < 1) return field.name
      })

      return !this.emptyFields.length
    },
    async publish() {
      if (this.fieldsCompleted()) {
        await this.$dialog.confirm('Are you sure you want to submit your review?')
        try {
          await this.publishContentById({ collection: 'linkbuilding', documentId: this.$route.params.id })
          if (process.env.NODE_ENV === 'production') {
            const adminEmail = this.getAdminEmail(this.linkbuilding.orderedById)
            const body = 'Received linkbuilding text with anchor text: ' + this.linkbuilding.anchors[0].text
            await this.sendLinkBuildingEmail(adminEmail, 'New LinkBuilding Text', body)
          }

          this.$notify({
            text: 'Successfully submitted linkbuilding text for review',
            type: 'success',
          })
        } catch (error) {
          this.$notify({
            text: 'Failed to submit linkbuilding text for review',
            type: 'error',
          })
        }
      } else {
        if (this.emptyFields.length == 1) {
          this.$dialog.alert(`The ${this.emptyFields[0]} field is empty<br><br>Make sure to fill it before submitting`, { html: true })
        } else {
          const fields = this.emptyFields
          const last = fields.pop()
          const finalString = fields.join(', ') + ' and ' + last
          this.$dialog.alert(`The following fields are empty:<br><br>${finalString}<br><br>Make sure to fill all fields before submitting`, { html: true })
        }
      }
    },
    async save() {
      try {
        await this.saveContentById({ collection: 'linkbuilding', documentId: this.$route.params.id })
        this.$notify({
          text: 'Successfully updated linkbuilding text',
          type: 'success',
        })
      } catch (error) {
        this.$notify({
          text: 'Failed to updated linkbuilding text',
          type: 'error',
        })
      }
    },
    async deleteLinkBuilding() {
      await this.$dialog.confirm("You're about to delete linkbuilding text. Please confirm since this action cannot be recovered.")
      try {
        await this.deleteContentById({ collection: 'linkbuilding', documentId: this.$route.params.id })
        this.$notify({
          text: 'Successfully deleted linkbuilding text',
          type: 'success',
        })
        this.$router.push('/')
      } catch (error) {
        this.$notify({
          text: 'Failed to deleted linkbuilding text',
          type: 'error',
        })
      }
    },
    async sendLinkBuildingEmail(recipients, subject, body) {
      var url = new URL('https://europe-west1-freelance-ffddb.cloudfunctions.net/send-email')
      url.searchParams.set('recipients', recipients)
      url.searchParams.set('subject', subject)
      url.searchParams.set('body', body)
      await axios.get(url)
    },
    getAdminEmail(adminId) {
      let email = null
      this.$store.getters.linkBuilderAdmins.forEach(admin => {
        if (admin.id === adminId) {
          email = admin.email
        }
      })
      return email
    },
  },
  computed: {
    ...mapGetters(['linkbuilding', 'user']),
    getTitle() {
      switch (this.linkbuilding.status) {
        case 'Live':
          return 'Live'
        case 'Exported':
          return 'Exported'
        case 'Approved':
          return 'Approved'
        case 'Pending Review':
          return 'Pending Review'
        default:
          return 'Update Link Building Text'
      }
    },
  },
  components: {
    LinkBuilding,
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared-styles/button.scss';

.delete {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #bcbccb;
  margin-left: auto;
  font-size: 0.875rem;
  cursor: pointer;
  & svg {
    margin-right: 0.5rem;
  }
  &:hover,
  &:hover > svg > * {
    color: #e05252;
    fill: #e05252;
  }
}
.button-container {
  display: flex;
}
</style>
